import { request } from '../axios/request';
import { objectSelector } from 'theme/utils';

import {
  FETCH_ORDER_PENDING,
  FETCH_ORDER_REJECTED,
  FETCH_ORDER_FULFILLED,
  RESET_ORDER,
} from '../constants/orderSearch';

const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);

const $ST = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/order`);

export const resetOrder = () => ({
  type: RESET_ORDER,
});

const pending = () => ({
  type: FETCH_ORDER_PENDING,
});

const fulfilled = (response) => ({
  type: FETCH_ORDER_FULFILLED,
  response: response,
});

const rejected = (error) => ({
  type: FETCH_ORDER_REJECTED,
  error: error,
});

export const fetchOrder = (form, main) => (dispatch) => {
  const { order: orderNumber } = form;
  const isBrandKoton = $A.BRAND === 'Koton';
  const cargoBaseCode = 'KRG0002XXXX';
  const baseUrl = `${$U.ORDER_DETAIL}${orderNumber}/`;

  dispatch(pending());

  const refundOrder = () => {
    const url = `${baseUrl}${main}`;

    request({ method: 'GET', url })
      .then((response) => {
        dispatch(fulfilled(response.data));
      })
      .catch((error) => {
        dispatch(rejected(error));
      });
  };

  const refundKotonOrder = () => {
    request({ method: 'GET', url: baseUrl })
      .then((res) => {
        const { orderitem_set, invoice_number, channel } = res.data;
        const isOrderCashOnDelivery = orderitem_set.some(
          (item) => item.product.base_code === cargoBaseCode
        );
        const isShopOrder = objectSelector(channel, 'channel_type') === 'web';

        let error = {
          response: { data: '' },
        };

        if (!invoice_number || isOrderCashOnDelivery || !isShopOrder) {
          error.response.data = !invoice_number
            ? $ST.ORDER_SEARCH.ORDER_UNRECEIPTED_ERROR_MESSAGE
            : (isOrderCashOnDelivery || !isShopOrder) &&
              $ST.ORDER_SEARCH.ORDER_REFUND_ERROR_MESSAGE;
          dispatch(rejected(error));
        } else {
          refundOrder();
        }
      })
      .catch((error) => {
        dispatch(rejected(error));
      });
  };

  isBrandKoton ? refundKotonOrder() : refundOrder();
};



// WEBPACK FOOTER //
// ./src/actions/orderSearch.js